import { Object } from '@common/Object/Object'

import { is } from '@common/is/is'

import { ENavigator } from '../../../navigator'

/**
 * Visszaadja egy komponens nevét a kapott `detail` alapján.
 * @param detail - A detail.
 */
export default function getComponent (detail: string): string | null {
  // Meg kell nézni, hogy egyáltalán létező eseményt adtunk-e meg.
  const matching = Object.getEntries(ENavigator).filter(([ _key, value ]) => value === detail)

  if (is.empty(matching)) {
    return null
  }

  if (detail === ENavigator.Demo || detail === ENavigator.Start) {
    return null
  }

  // Ebben az egy esetben eltérő.
  if (detail === ENavigator.Congrats) {
    return 'a-congratulations'
  }

  return `a-${ detail }`
}
